import { render, staticRenderFns } from "./AutoCloseTooltip.vue?vue&type=template&id=37ead8c3&scoped=true&"
import script from "./AutoCloseTooltip.vue?vue&type=script&lang=ts&"
export * from "./AutoCloseTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./AutoCloseTooltip.vue?vue&type=style&index=0&id=37ead8c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ead8c3",
  null
  
)

export default component.exports